{
  "Language": {
    "Name": "Français",
    "Locality": "Canada"
  },
  "Breadcrumb": {
    "Home": "Accueil",
    "UserLookup": "Rechercher un utilisateur",
    "UserRoles": "Rôles d'utilisateur",
    "LocationManager": "Gestionnaire d'emplacements",
    "EditLocation": "Modifier l'emplacement",
    "AddNewUser": "Ajouter un nouvel utilisateur",
    "EditUserRole": "Modifier le rôle d'utilisateur",
    "AddNewRequest": "Créer une demande",
    "RequestDetails": "Détails de la demande",
    "EditRoles": "Modifier les rôles",
    "LocationUserManagement": "Gestion des emplacements et des utilisateurs",
    "UserAccessHistory": "Historique des accès d'utilisateur",
    "AddNewUsers": "Ajouter de nouveaux utilisateurs",
    "NotificationSettings": "Paramètres de notification"
  },
  "Term": {
    "TrailerReservationSystem": "Système de Réservation de Remorque",
    "TrailerReservationSuite": "Suite de Réservation de Remorque",
    "NetworkCarrierManagement": "Gestion des transporteurs en réseau",
    "Sort": "Tri",
    "Planned": "Planifié",
    "AdHoc": "AD HOC",
    "Next": "Suivant",
    "Cancel": "Annuler",
    "Edit": "Modification",
    "New": "Nouveau",
    "Submit": "Soumettre",
    "Enabled": "Activé",
    "Disabled": "Désactivé",
    "Continue": "Continuer",
    "Confirm": "Confirmer",
    "UpsId": "Code d'utilisateur ups.com",
    "Email": "Courriel",
    "Role": "Rôle",
    "RequiredFieldNotice": "Indique un champ obligatoire.",
    "Delete": "Supprimer",
    "Yes": "Oui",
    "No": "Non",
    "AreYouSure": "Êtes-vous certain?",
    "Location": "Emplacement",
    "Locations": "Emplacements",
    "User": "Utilisateur",
    "Users": "Utilisateurs",
    "Date": "Date",
    "Reason": "Raison",
    "Selected": "Choisi",
    "Or": "ou",
    "To": "À",
    "Phone": "Téléphone",
    "By": "par",
    "Displaying": "Affichage de",
    "BasedOnSearchResults": "selon les résultats de la recherche",
    "BasedOnSearchResultsLocationUsers": "en fonction des résultats de la recherche.",
    "Loading": "Chargement en cours...",
    "Custom": "personnalisé",
    "CountryCode": "Code de Pays",
    "LocationCode": "Code d'emplacement",
    "LocationSlic": "SLIC d'emplacement",
    "UserId": "Code d'utilisateur",
    "On": "Activer",
    "Off": "Désactiver",
    "OfSingle": "de",
    "OfMultiple": "des"
  },
  "Role": {
    "Administrator": "Administrateur",
    "ViewEdit": "Consultation et modification",
    "ViewOnly": "Consultation seulement",
    "NoAccess": "Aucun accès"
  },
  "ServiceLevel": {
    "Ground": "Standard",
    "Air": "Service aérien",
    "NextDayAir": "Next Day Air",
    "SecondDayAir": "Second Day Air",
    "ThreeDaySelect": "Three Day Select",
    "EarlyAM": "Early AM"
  },
  "TrailerType": {
    "Short": "Courte",
    "Long": "Longue",
    "Air": "Service aérien"
  },
  "TrailerSize": {
    "Short": "Courte",
    "Long": "Longue",
    "Air": "Service aérien"
  },
  "Sort": {
    "Sunrise": "Aube",
    "Preload": "Préchargement",
    "Morning": "Matin",
    "Day": "Jour",
    "Afternoon": "Après-midi",
    "Local": "Local",
    "Twilight": "Soir",
    "Night": "Nuit",
    "TotalUsers": "Utilisateurs totales"
  },
  "RequestType": {
    "Delivery": "Livraison",
    "LiveLoad": "Chargement direct",
    "Switch": "Échange",
    "RetrieveEmpty": "Récupérer vide",
    "RequestEmpty": "Demander vide",
    "RetrieveLoad": "Récupérer chargement",
    "Other": "Autre",
    "REALIGN": "Repositionnement"
  },
  "DatePicker": {
    "StartDate": "Date de début",
    "EndDate": "Date de fin",
    "Today": "Aujourd'hui",
    "Clear": "Effacer",
    "Close": "Fermer",
    "DateFormatting": "YYYY-MM-DD",
    "PriorComments": "commentaires non lus sur des dates antérieures",
    "FutureComments": "commentaires non lus sur les dates futures"
  },
  "HomePage": {
    "Header": "Tableau de bord des réservations",
    "LocationManager": "Gestionnaire d'emplacements",
    "LocationUserManager": "Gestion des emplacement et des utilisateurs",
    "UserLookup": "Rechercher un utilisateur",
    "AddRequest": "Créer une nouvelle demande",
    "RequestType": "Type de demande",
    "TrailerType": "Type de remorque",
    "TrailerSize": "Taille de la remorque",
    "Destination": "Destination",
    "DestinationSort": "Tri de destination",
    "ServiceLevel": "Type de service",
    "EarliestDueDate": "Date limite (au plus tôt)",
    "LatestDueDate": "Date limite (au plus tard)",
    "Apply": "Appliquer",
    "ClearFilters": "Effacer les filtres",
    "Status": "Statut",
    "Type": "Type",
    "EarliestTime": "Heure (au plus tôt)",
    "LatestTime": "Heure (au plus tard)",
    "UPSLocationCode": "Code d'emplacement UPS",
    "LocationName": "Nom de l'emplacement",
    "SearchRequests": "Recherches",
    "SortBy": "Trier par",
    "FSNoticeTitle": "Attention!",
    "FSNoticeText": "La plage de dates que vous avez sélectionnée peut contenir des demandes planifiées non affichées sur cette page. Les demandes planifiées qui auront lieu après ce samedi peuvent ne pas être visibles.",
    "UnreadComments": "Commentaires non lus",
    "LocationCode": "Code d'emplacement",
    "CustomLocationName": "Nom d'emplacement personnalisé",
    "TotalRequests": "Demandes totales",
    "StateProvinceTerritory": "État/Province/Territoire",
    "PendingRequests": "Demandes en attente",
    "InProgressRequests": "Demandes en cours",
    "CompletedRequests": "Demandes complétées",
    "ExportRequests": "Exporter les demandes",
    "TrailerRequestsExportFilename": "Tableaudebord_Remorques",
    "NoResultsMatched": "Aucun résultat ne correspond aux critères actuels.",
    "TrailerDirection": "Direction de la remorque",
    "TrailerVolume": "Volume de la remorque",
    "Volume": "Volume",
    "NoVolume": "Aucun Volume",
    "Pallets": "Palettes",
    "Gaylords": "Grands emballages",
    "FromUPS": "En provenance d'UPS",
    "ToUPS": "À destination d’UPS",
    "PlanNotMet": "Pas exécuté comme prévu",
    "NotPlanned": "Pas prévu",
    "TractorOnly": "Tracteur seulement",
    "NotificationSettings": "Paramètres de notification",
    "CreatedAs": "Créée en tant que",
    "Requests": "Demandes",
    "OnProperty": "Sur place",
    "DestinationDoesNotExist": "La destination n'existe pas"
  },
  "FilterChip": {
    "TotalRequests": "Demandes totales",
    "NotFulfilled": "Non exécutée(s)",
    "Pending": "En attente",
    "Approved": "Approuvée(s)",
    "Scheduled": "Planifiée(s)",
    "InTransit": "En transit",
    "OnProperty": "Sur place",
    "Completed": "Complétée(s)",
    "Canceled": "Annulée(s)",
    "Canceling": "Annulation",
    "Attention": "Attention",
    "Needed": "Nécessaire"
  },
  "TrailerCard": {
    "No": "Nᵒ",
    "ArriveTime": "Heure d'arrivée prévue",
    "Arriving": "Arrivée prévue",
    "Arrived": "Arrivée",
    "Job": "Tâche",
    "Tractor": "Tracteur",
    "FromUPS": "En provenance d'UPS",
    "ToUPS": "À destination d’UPS",
    "Bay": "Quai",
    "Pallets": "Palette(s)",
    "Approved": "Approuvée",
    "Scheduled": "Planifiée",
    "InTransit": "En transit",
    "OnProperty": "Sur place",
    "Complete": "Complétée",
    "Details": "Détails",
    "Contact": "Contact",
    "Earliest": "Au plus tôt",
    "Latest": "Au plus tard",
    "PullTime": "Heure de retrait",
    "Due": "Dû le",
    "Comments": "Commentaires",
    "NotPlanned": "Pas prévu",
    "DriverCreatedRequest": "Demande créée par le conducteur",
    "TractorOnly": "Tracteur seulement"
  },
  "LocationList": {
    "SearchLocations": "Rechercher des emplacements",
    "AllLocations": "Tous les emplacements",
    "Pending": "En attente",
    "InProgress": "En cours",
    "Completed": "Complétée(s)",
    "LoadMore1": "Charger Emplacements",
    "LoadMore2": "Suivants",
    "CustomNameHyperlink": "Assigner un nom personnalisé",
    "PendingRemoval": "En attente de suppression",
    "OpenOnPropertyView": "Vue de la propriété"
  },
  "AddRequestPage": {
    "Header": "Création d’une demande",
    "Description": "Utilisez les champs ci-dessous pour décrire votre demande.",
    "CustomerLocation": "Emplacement du client",
    "RequestType": "Type de demande",
    "ValidLocation": "Veuillez sélectionner un emplacement valide"
  },
  "RequestFormPage": {
    "Description": "Utilisez les champs ci-dessous pour décrire votre demande.",
    "RequestWindow": "Formulaire de demande",
    "EarliestDate": "Date (au plus tôt)",
    "EarliestTime": "Heure (au plus tôt)",
    "LatestDate": "Date (au plus tard)",
    "LatestTime": "Heure (au plus tard)",
    "LoadedTrailer": "Remorque chargée",
    "DestinationFacility": "Installations UPS de destination",
    "DestinationSort": "Tri de destination",
    "TrailerType": "Type de remorque/taille",
    "TrailerSize": "Taille de la remorque",
    "TrailerNumber": "Numéro de remorque",
    "ServiceLevel": "Type de service",
    "FillOneOfThree": "Vous devez remplir au moins un des trois champs suivants concernant le contenu du chargement.",
    "FillOneOfTwo": "Vous devez remplir au moins un des deux champs suivants concernant le contenu du chargement.",
    "OptionalLoadFields": "Les trois champs suivants concernant le contenu du chargement sont facultatifs.",
    "Pieces": "Nombre de pièces",
    "Pallets": "Nombre de palettes",
    "Fullness": "Pourcentage de chargement",
    "Gaylords": "Nombre de grands emballages",
    "Bags": "Nombre de sacs",
    "Irregs": "Nombre de pièces irrégulières",
    "Quantity": "Quantité",
    "EmptyTrailer": "Remorque vide",
    "Bay": "Quai/porte",
    "AdditionalInformation": "Renseignements additionnels",
    "RequestReason": "Pourquoi demandez-vous un mouvement supplémentaire?",
    "DeliveryNumber": "Numéro de livraison",
    "PickupNumber": "Numéro de ramassage",
    "SpecialInstructions": "Directives spéciales",
    "IfYouContinue": "Si vous continuez",
    "ThisRequestWillNotBeCreated": "cette demande ne sera pas créée",
    "YourEditsWillNotBeSaved": "vos modifications ne seront pas enregistrées",
    "ThisRequestWillNotBeSaved": "cette demande ne sera pas enregistrée.",
    "MustBeInTheFuture": "Veuillez choisir une date ultérieure",
    "MustBeWithin90DaysFromToday": "La date doit se situer à l’intérieur de 90 jours",
    "MustBeBeforeLatestPickup": "Doit être avant le dernier ramassage",
    "MustBeAfterEarliestPickup": "Doit être après le premier ramassage",
    "ThisFieldIsRequired": "Ce champ est obligatoire.",
    "MustBeValidPercent": "Doit être un pourcentage valide",
    "MustBeGreaterThanZero": "Doit être supérieur à zéro",
    "Edit": "Modification -",
    "New": "Nouveau -",
    "WeekendNotificationTitle": "Avertissement!",
    "WeekendNotificationMessage": "Vous êtes sur le point de soumettre une demande la fin de semaine. Veuillez noter que certaines installations UPS sont fermées la fin de semaine. Il est possible que vous ne receviez pas de réponse avant lundi.",
    "PeakSeasonDateRangeWarning": "Cette demande survient durant la période de pointe d'UPS et sera évaluée le ",
    "InvalidTime": "L’heure ne se situe pas dans la plage valide.",
    "InvalidDate": "La date ne se situe pas dans une plage de dates valide.",
    "InvalidFieldNotification": "Les valeurs de certains champs ne sont pas valides. Veuillez corriger chaque champ et soumettre de nouveau.",
    "ServerFailureNotification": "Erreur de soumission de la demande. Veuillez essayer de nouveau. Si le problème persiste, veuillez communiquer avec le centre de répartition des installations UPS de destination sélectionnées.",
    "LocationSetupIncompleteMessage": "n'est pas actuellement configuré pour ajouter de nouvelles demandes dans le Système de Réservation de Remorque (TRS).  Veuiillez contacter votre répartition locale.",
    "LocationSetupIncomplete": "Configuration de l'emplacement incomplète",
    "LocationIncomplete": "L'emplacement",
    "DestinationSetupIncompleteMessage": "La destination/le tri que vous avez sélectionée n'est pas configurée pour ajouter de nouvelles demandes. Veuillez modifier la destination/le tri ou contacter votre répartition locale.",
    "DefaultResponsibleLocation" : "Emplacement UPS attitré"


  },
  "Header": {
    "ProfileOverview": "Aperçu du profil",
    "MyInformation": "Mes renseignements",
    "Addresses": "Adresses",
    "AccountsPayment": "Comptes et paiement",
    "Preferences": "Préférences",
    "ViewPayBill": "Consulter et payer la facture",
    "LogOut": "Se déconnecter",
    "SignUp": "S'inscrire"
  },
  "Footer": {
    "PrivacyPolicy": "Déclaration de confidentialité",
    "TermsConditions": "Modalités et conditions du service",
    "Legal": "Service juridique"
  },
  "RequestDetailsPage": {
    "Header": "Détails de la demande",
    "GeneralInformation": "Renseignements généraux",
    "RequestId": "Code de demande",
    "RequestInstructions": "Directives de la demande",
    "Created": "Créé",
    "Date": "Date",
    "Edited": "Modifiée",
    "Approved": "Approuvée",
    "Canceled": "Annulée",
    "Canceling": "Annulation",
    "Rejected": "Non exécutée",
    "UserId": "Code d'utilisateur",
    "BayNumber": "Numéro de baie",
    "Bags": "Sacs",
    "DeliveryNumber": "Numéro de livraison",
    "Destination": "Destination",
    "DestinationSort": "Tri de destination",
    "DueDate": "Date limite",
    "Earliest": "Au plus tôt",
    "Gaylords": "Grands emballages",
    "Irregs": "Irréguliers",
    "Latest": "Au plus tard",
    "NotFulfilledReason": "Raison demande non exécutée",
    "Pallets": "Palettes",
    "PercentFull": "Pourcentage plein",
    "Pieces": "Pièces",
    "PickupNumber": "Numéro de ramassage",
    "Reason": "Raison",
    "RequestStatus": "État de la demande",
    "RequestType": "Type de demande",
    "ServiceLevel": "Niveau de service",
    "SpecialInstructions": "Instructions spéciales",
    "TrailerNumber": "Numéro de remorque",
    "TrailerType": "Type de remorque",
    "TrailerSize": "Taille de la remorque",
    "Pending": "En attente",
    "CustomerSelected": "Client sélectionné",
    "TransferRequested": "Transfert demandé",
    "TransferApproved": "Transfert approuvé",
    "TransferRejected": "Transfert refusé",
    "InTransit": "En transit",
    "OnProperty": "Sur place",
    "PickedUp": "Ramassé",
    "Completed": "Complétée",
    "Scheduled": "Planifiée",
    "Transferred": "Transféré",
    "UndoTransfer": "Annuler le transfert"
  },
  "LocationManagerPage": {
    "Header": "Gestionnaire d'emplacements",
    "LocationCode": "Code d'emplacement",
    "CustomLocationName": "Nom d'emplacement personnalisé",
    "PickupAddress": "Adresse de ramassage",
    "Users": "Utilisateurs",
    "Actions": "Actions",
    "EditLocation": "Modifier le nom/les utilisateurs"
  },
  "LocationUserPage": {
    "RemoveUser": "Supprimer l'utilisateur",
    "Users": "Utilisateurs",
    "Edit": "Modification",
    "SearchUsers": "Rechercher des utilisateurs",
    "ServerFailureNotification": "Une erreur est survenue lors du traitement de cette demande. Veuillez réessayer.",
    "NoLocationsMatch": "Aucun résultat ne correspond aux critères de recherche",
    "NewUserRequests": "Demandes de nouveaux utilisateurs",
    "AllUsers": "Tous les utilsateurs",
    "NoUserRequestsToReviewPart1": "Il n’y a actuellement aucune nouvelle demande d’utilisateur à passer en revue. Un indicateur orange numéroté",
    "NoUserRequestsToReviewPart2": "apparaît lorsqu’il y a de nouvelles demandes.",
    "LastUpdated": "Dernière mise à jour",
    "By": "par",
    "SortLocationsBy": "Trier les emplacements par",
    "Export": "Exporter",
    "LocationUserExportFilename": "EmplacementsEtUtilisateurs",
    "SortUsersBy": "Trier les utilisateurs par",
    "UserId": "Code d'utilisateur",
    "Email": "Courriel",
    "NumberOfLocations": "Nombre des emplacements"
  },
  "LocationPage": {
    "Header": "Modification de l'emplacement",
    "CustomLocationName": "Nom d'emplacement personnalisé",
    "AddUsers": "Ajouter des utilisateurs",
    "LastUpdated": "Dernière mise à jour",
    "Actions": "Actions",
    "EditRole": "Modifier le rôle",
    "Users": "Utilisateurs",
    "NewUserRequests": "Demandes de nouveaux utilisateurs",
    "Approve": "Approuver",
    "Deny": "Refuser",
    "ChangesSaved": "Changements sauvegardés",
    "CustomNameRequired": "Un nom personnalisé est obligatoire.",
    "RemoveSelectedUsers": "Retirer les utilisateurs sélectionnés"
  },
  "LocationManagerEditRolePage": {
    "Header": "Modification du rôle de l'utilisateur",
    "RemoveUser": "Supprimer l'utilisateur"
  },
  "UserRolesPage": {
    "Header": "Rôles d'utilisateur",
    "AddNewRoles": "Ajouter de nouveaux rôles/emplacements",
    "LocationCode": "Code d'emplacement",
    "CustomLocationName": "Nom d'emplacement personnalisé",
    "LastUpdated": "Dernière mise à jour",
    "Actions": "Actions",
    "Remove": "Supprimer",
    "RemoveFromListedLocations": "Supprimer des emplacements répertoriés",
    "EditRole": "Modifier le rôle"
  },
  "AddUserPage": {
    "Header": "Nouveaux utilisateurs",
    "User": "Utilisateur",
    "AddAnother": "Ajouter un autre utilisateur",
    "UserExistsAtLocation": "L'utilisateur existe déjà à cet emplacement.",
    "DuplicateId": "Reproduire le code d'utilisateur ups.com",
    "EmailInvalid": "Le courriel n'est pas valide.",
    "RoleInvalid": "Le rôle n'est pas valide",
    "ThisFieldIsRequired": "Ce champ est obligatoire.",
    "UpsIdExistsAtLocation": "Ce code d’utilisateur ups.com existe déjà à cet emplacement.",
    "UserQueueCancelMessage": "Si vous continuez, ces utilisateurs ne seront pas ajoutés aux emplacements que vous avez indiqués.",
    "NewUserQueue": "File d'attente des nouveaux utilisateurs",
    "EntriesListed": "entrées réportoriées",
    "AddNewUsers": "Ajouter des utilisateurs",
    "SearchAndAddLocations": "Rechercher et ajouter des emplacements",
    "AddToQueue": "Ajouter à la file d'attente",
    "ServerFailureNotification": "Une erreur est survenue lors du traitement de cette demande. Veuillez réessayer.",
    "DeleteUser": "Supprimer l'utilisateur",
    "DownloadTemplate": "Télécharger le modèle",
    "LocationUserImportTemplateFilename": "Modèle d'importation",
    "ImportUsers": "Importer les utilisateurs",
    "EntriesNeedAttention": "entrées nécessitent votre attention",
    "EntryNeedsAttention": "entrée nécessite votre attention",
    "InvalidUPSId": "Veuillez saisir un code d'utilisateur UPS.com valide"
  },
  "UserLookupPage": {
    "Header": "Recherche d’un utilisateur",
    "Description": "Vous devez remplir au moins un des deux champs suivants.",
    "NoInputError": "Veuillez remplir un des champs.",
    "NoResultsError": "Aucun résultat"
  },
  "RequestCategory": {
    "Planned": "Planifiée",
    "AdHoc": "AD HOC"
  },
  "Legal": {
    "TermsNotice1": "En soumettant cette demande de remorque, j'accepte les modalités des",
    "TermsNotice2": "Modalités et conditions du service",
    "TermsNotice3": "et de",
    "TermsNotice4": "l'Entente relative à l'utilisation des technologies UPS",
    "TermsNotice5": "et comprenez que de telles modalités UPS s'appliquent à ma demande de remorque.",
    "Copyright": "Copyright",
    "CopyrightDisclaimer": "United Parcel Service of America, Inc. Tous droits réservés.",
    "TermsAndConditionsUrl": "https://www.ups.com/assets/resources/media/fr_CA/terms_service_ca.pdf",
    "TechnologyAgreementUrl": "https://www.ups.com/assets/resources/media/fr_CA/UTA.pdf",
    "PrivacyPolicyUrl": "https://www.ups.com/ca/fr/help-center/legal-terms-conditions/privacy-notice.page",
    "TermsOfServiceUrl": "https://www.ups.com/ca/fr/help-center/legal-terms-conditions/website.page"
  },
  "EditUserPage": {
    "Header": "Modification du rôle d'utilisateur",
    "RemoveUser": "Supprimer l'utilisateur"
  },
  "ModalText": {
    "DeleteNewRole": "Si vous continuez, cet utilisateur ne sera pas ajouté à cet emplacement et ne pourra pas consulter ou modifier des réservations.",
    "CancelAddUsersSingle": "Si vous continuez, cet utilisateur ne sera pas ajouté à cet emplacement et ne pourra pas consulter ou modifier des réservations.",
    "CancelAddUsersMultiple1": "Si vous continuez",
    "CancelAddUsersMultiple2": "ne sera pas ajouté à cet endroit et ne pourra pas consulter ou modifier des réservations.",
    "DenyUserRequest": "Si vous continuez, cette demande sera refusée de manière permanente.",
    "DeleteEditRole": "Si vous continuez, cet utilisateur ne pourra pas consulter ou modifier cet emplacement.",
    "RemoveUser": "Si vous continuez, cet utilisateur n'aura plus accès à cet emplacement.",
    "DeleteFromLocation": "Si vous continuez, cet utilisateur n'aura plus accès à aucun de ces emplacements.",
    "DeleteUsersFromLocation": "Si vous continuez, ces utilisateurs n’auront plus accès à cet emplacement."
  },
  "CancelModal": {
    "Description": "Si vous continuez, cette demande sera annulée de manière permanente.",
    "RequestType": "Type de demande",
    "PleaseEnterAReason": "Veuillez entrer une raison pour laquelle cette demande sera annulée.",
    "Holiday": "Congé férié",
    "Weather": "Conditions météorologiques",
    "Volume did not generate": "Volume inférieur aux prévisions",
    "Duplicate request": "Demande en double",
    "Other": "Autre",
    "OtherPleaseSpecify": "Autre (à préciser)",
    "OtherReason": "Autre raison",
    "Scheduling error": "Erreur de planification",
    "Covered by Package Center": "Service par centre de colis",
    "FailedToSaveChanges": "Les modifications n'ont pas été enregistrées. Veuillez réssayer."
  },
  "AddNewRolesPage": {
    "Header": "Ajout de nouveaux rôles",
    "AddAnotherLocation": "Ajouter un autre emplacement",
    "LocationIsRequired": "L'emplacement est obligatoire.",
    "RoleIsRequired": "Un rôle est obligatoire."
  },
  "EditRolesPage": {
    "Header": "Modification des rôles"
  },
  "ContactModal": {
    "Header": "Coordonnées",
    "ResponsibleUpsLocation": "Emplacement UPS attitré",
    "Phone": "Téléphone",
    "Email": "Courriel",
    "Continue": "Continuer",
    "Sunday": "Dimanche",
    "Monday": "Lundi",
    "Tuesday": "Mardi",
    "Wednesday": "Mercredi",
    "Thursday": "Jeudi",
    "Friday": "Vendredi",
    "Saturday": "Samedi",
    "HoursOfOperation": "Heures d'ouverture",
    "NoAvailableInformation": "Aucune information disponible",
    "Open24Hours": "Ouvert 24 heures sur 24",
    "Closed": "Fermé"
  },
  "NoLocationPage": {
    "Header": "Tableau de bord de réservation",
    "NoticeTitle": "Attention!",
    "NoticeText": "Vous n'avez pas encore d'emplacement dans votre profil. Contactez votre administrateur ou un centre d'expédition UPS pour demander un accès."
  },
  "CommentsModal": {
    "AddComment": "Ajouter un commentaire",
    "PreviousComments": "Commentaires précédents",
    "CommentRefresh": "Commentaires actualisation",
    "FailedToSubmit": "Échec de la soumission de votre message. Veuillez réessayer."
  },
  "CustomNameModal": {
    "CustomLocationName": "Nom d'emplacement personnalisé",
    "CustomNameWarning": "Cette modification sera appliquée à tous les utilisateurs",
    "EditLocationName": "Modifier le nom d’emplacement",
    "NewLocationName": "Nouveau nom d’emplacement",
    "CurrentLocationName": "Nom d'emplacement actuel",
    "LastUpdated": "Dernière mise à jour",
    "SaveFailed": "Les modifications n'ont pas été enregistrées. Veuillez réssayer"
  },
  "RemoveUserModal": {
    "RemoveUser": "Si vous continuez, cet utilisateur n’aura plus accès à aucun de ces emplacements.",
    "SaveFailed": "Les modifications n'ont pas été enregistrées. Veuillez réssayer"
  },
  "TimeZones": {
    "EST": "HNE",
    "EDT": "HAE",
    "CST": "HNC",
    "CDT": "HAC",
    "MST": "HNR",
    "MDT": "HAR",
    "PST": "HNP",
    "PDT": "HAP",
    "AST": "HNA",
    "ADT": "HAA"
  },
  "RequestRejection": {
    "SelectResponse": "Sélectionnez une réponse",
    "CancelResponse": "Annuler la demande",
    "FulfillRequestOn": "Répondre à la demande le ",
    "AndProcessOn": " et traiter sur ",
    "EarliestTimeAfterCriticalPullTime": "Le temps disponible le plus tôt est après le temps de tirage critique",
    "NetworkOverCapacity": "Le réseau est en surcapacité",
    "SubmittedAfterCutoffTime": "Soumis après l'heure limite de demande",
    "VolumeDoesNotJustifyPickup": "Le volume ne justifie pas le ramassage de la remorque",
    "VolumeOverAllocation": "Volume sur allocation",
    "Weather": "La météo",
    "RequestMovedTo": "Cette demande sera déplacée vers ",
    "RequestMovedToCanceledStatus": "Cette demande passera au statut Annulé",
    "PeakVolumeOverAllocation": "Volume de période de pointe au-delà de l’attribution",
    "UPSHoliday": "Congé férié UPS",
    "CustomerHasSufficientEquipment": "Équipement en quantité suffisante chez le client",
    "NoEquipmentAvailable": "Aucun équipement disponible",
    "NoResponseFromCustomer": "Aucune réponse du client",
    "NotFulfilled": "Non exécutée"
  },
  "Months": {
    "January": "janvier",
    "February": "février",
    "March": "mars",
    "April": "avril",
    "May": "mai",
    "June": "juin",
    "July": "juillet",
    "August": "août",
    "September": "septembre",
    "October": "octobre",
    "November": "novembre",
    "December": "décembre"
  },
  "SystemMessage": {
    "OneOfOne": "1 de 1",
    "DownForMaintenance": "Le Système de réservation de remorques est actuellement hors service pour des raisons de maintenance."
  },
  "UserAccessHistory": {
    "UserInformation": "Information d'utilsateur",
    "Date": "Date",
    "Time": "Temps",
    "Location": "Emplacement",
    "Role": "Rôle",
    "Activity": "Activité",
    "UserId": "Code",
    "Entry": "entrée",
    "Entries": "entrées",
    "SearchChangeHistory": "Rechercher l'historique des modifications"
  },
  "UserAccessActivity": {
    "Submitted": "Soumis",
    "Added": "Ajouté",
    "Removed": "Supprimé",
    "Approved": "Approuvé",
    "Denied": "Refusé",
    "Updated": "Modifié"
  },
  "Toast": {
    "FailedToSaveChanges": "Les modifications n'ont pas été enregistrées. Veuillez réssayer.",
    "UserDataIsStale": "Un autre utilisateur a modifié ces informations depuis le dernier chargement de la page. Cliquez ici pour actualiser la page maintenant ou attendez 30 secondes que la page soit actualisée.",
    "StorageAccountIsDown": "Un promlème temporaire est survenu lors de l'envoi de demandes à Répartition. Si vous devez contacter Répartition avant de résoudre ce problème, cliquez sur le lien \"Contact\" bleu situé dans le coin supérieur droit de la demande. Lorsque la connexion est rétablie, cette bannière disparaît.",
    "FailedToExport": "Échec de l'exportation. Veuillez réessayer.",
    "FailedToRetrieveOnPropertyData": "Échec de chargement des données relatives aux remorques se trouvant sur place. Veuillez rafraîchir la page."
  },
  "ImportUsersErrorModal": {
    "ImportErrorHeader": "Impossible d'importer",
    "ImportErrorBody": "Vérifiez que vous importez le modèle Excel fourni et que toutes les colonnes sone remplies correctement."
  },
  "InvalidImportEntriesModal": {
    "InvalidImportEntriesHeader": "Impossible d'importer certains utilisateurs",
    "InvalidImportEntriesDueTo": "En raison d'erreurs dans le fichier Excel, ",
    "InvalidImportEntriesUsersWereNotImported": " utilisateurs n'ont pas été importés. Veuillez effecteur les corrections nécessaires dans le fichier Excel avant réessayer de les importer.",
    "InvalidImportEntriesNote": "Remarque: L'importation de nouveau de l'intégralité du fichier Excel n'entraîne pas de doublons. Sueles les entrées nouvelles et corrigées seront ajoutées à la file d'attente des nouveaux utilsateurs",
    "InvalidImportEntriesTheseWere": "Il s'agit des ",
    "InvalidImportEntriesErrorsFound": " erreurs trouvées dans le fichier Excel."
  },
  "ExportModal": {
    "ExportCommentsHeader": "Inclure les commentaires dans le fichier d’exportation?",
    "ExportCommentsBodyText": "Inclure des commentaires dans le fichier d’exportation peut entraîner l’ajout de rangées comportant des renseignements répétitifs.",
    "ExportCommentsBodyExplanation": "Par exemple, si une demande comporte trois (3) commentaires, cette demande s’affichera trois (3) fois et tous les renseignements seront identiques, à l’exception du commentaire.",
    "ExportCommentsCheckLabel": "Oui, inclure les commentaires dans ce fichier d’exportation.",
    "Export": "Exporter",
    "FailedToExport": "Échec de l'exportation. Veuillez réessayer."
  },
  "NotificationSettings": {
    "NotificationSettings": "Paramètres de notification",
    "DeliveryType": "Méthode de notification",
    "EmailNotifications": "Notifications par courriel",
    "AddEmailAddress": "Ajouter courriel",
    "AttentionNeeded": "Attention Nécessaire",
    "Pending": "En attente",
    "Approved": "Approuvée",
    "Scheduled": "Planifiée",
    "InTransit": "En transit",
    "OnProperty": "Sur place",
    "Completed": "Complétée",
    "Canceled": "Annulée",
    "StatusChange": "Modification de statut",
    "AllToggles": "Toutes les sélections",
    "Comment": "Commentaire",
    "RequestEdited": "Modification des demandes",
    "UserRequest": "Demande d'accès d'un utilisateur",
    "NotificationsToReceive": "Notifications à recevoir",
    "StatusChangeOn": "Changements de statut activés",
    "CommentOn": "Commentaires activés",
    "RequestEditedOn": "Modifications activés",
    "AdminLocations": "Emplacements d'accès administrateur",
    "NoResultsMatched": "Aucun résultat ne correspond aux critères de recherche.",
    "Displaying": "Affichage de",
    "SortInstructions": "Sélectionnez un emplacement pour modifier ses paramètres. Vous pouvez choisir plusieurs emplacements à la fois pour la gestion.",
    "AddAnotherEmail": "Ajouter un courriel",
    "WeeklyPlannedRequest": "Demande Planifiée Hebdomadaire",
    "WeeklyPlannedRequestInfo": "Activez cette option pour recevoir un email pour\nchaque demande planifiée lors du téléchargement\nhebdomadaire. Par exemple, 1 500 demandes\nplanifiées généreront 1 500 emails."
  },
  "DeliveryTypeModal": {
    "DeliveryTypeHeader": "Modifier de coordonnées",
    "DeliveryTypeSubText": "Veuillez mettre à jour vos coordonnées préférées",
    "EmailInvalid": "Le format n’est pas valide.",
    "PhoneInvalid": "Le format n’est pas valide.",
    "SaveFailed": "Les modifications n'ont pas été enregistrées. Veuillez réessayer."
  },
  "OnProperty": {
    "OnPropertyView": "Vue de la propriété",
    "SearchYourLocations": "Rechercher des emplacements",
    "NoResultsMatched": "Aucun résultat ne correspond aux critères de recherche.",
    "Showing": "Affichage de",
    "Trailers": "remorques",
    "DayOP": "jour SP",
    "DaysOP": "jours SP",
    "Of": "des",
    "SearchAllTrailers" : "Rechercher des remorques",
    "NoDataForLocation": "Les données relatives aux remorques se trouvant sur place ne sont pas disponibles pour cet emplacement.",
    "ExportTrailerList": "Exporter liste des remorques",
    "TrailerListExportSuccess": "Liste des remorques exportée avec succès.",
    "TrailerListExportFailure": "Échec de l'exportation. Veuillez réessayer.",
    "TrailerListExportFileName": "TRS_remorque_exportation",
    "Available": "Disponible",
    "Empty": "Vide",
    "PullTime": "Temps de traction",
    "TrailerState": "État de la remorque"
  },
  "StatusValues": {
    "Pending": "En attente",
    "Approved": "Approuvée(s)",
    "Scheduled": "Planifiée(s)",
    "InTransit": "En transit",
    "OnProperty": "Sur place",
    "Completed": "Complétée(s)",
    "Canceled": "Annulée(s)",
    "Canceling": "Annulation",
    "NotFulfilled": "Non exécutée(s)"
  }
}
